import React, { Component } from 'react'
import PhoneInput, {
    isValidPhoneNumber,
    formatPhoneNumberIntl,
} from 'react-phone-number-input'
import CommonFetch from '../../../requests/commonFetch'

const SendPhoneNumber = props => {
    let {
        confirmPhone,
        currentData,
        removePhone,
        dataProtection,
        nameInput,
        handlePhoneNumberChange,
    } = props

    let numberIntl = formatPhoneNumberIntl(currentData['value'])
    let formData = new FormData()

    if (removePhone) {
        formData.append('phone', '')
    } else {
        formData.append('phone', numberIntl.replace(/\D/g, ''))
    }

    if (confirmPhone) {
        handlePhoneNumberChange(['confirmPhone'])
    }

    CommonFetch({
        path: 'ui/investor_settings/post_changephone',
        method: 'POST',
        data: formData,
    }).then(data => {
        if (data.success) {
            if (removePhone) {
                handlePhoneNumberChange(['removePhone', 'phoneCode'])
                dataProtection('update')
            } else {
                handlePhoneNumberChange(['confirmPhone'])
                nameInput()
            }
            console.log(data)
        }
    })
}

export default SendPhoneNumber
